import { render, staticRenderFns } from "./Seo6.vue?vue&type=template&id=9b35489c&scoped=true&"
import script from "./Seo6.vue?vue&type=script&lang=js&"
export * from "./Seo6.vue?vue&type=script&lang=js&"
import style0 from "./Seo6.vue?vue&type=style&index=0&id=9b35489c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b35489c",
  null
  
)

export default component.exports